import React from 'react';
import { IMessage } from '../../screens/Prompt/Prompt';
import AppCSS from '../../utils/styled';
import { styled } from 'styled-components';

export function Message({ message, isStreamed = false }: { message: IMessage; isStreamed?: boolean }) {
  return (
    <MessageWrapper key={message.id} $isUser={message.sender === 'user'}>
      <MessageSender $isUser={message.sender === 'user'}>
        {message.sender === 'user' ? 'You' : 'Assistant'}
      </MessageSender>
      <MessageBubble $isUser={message.sender === 'user'}>
        {isStreamed ? (
          <>
            {message.text.substring(0, message.text.length - 1)}
            <MessageStreamedLetter>{message.text.at(-1)}</MessageStreamedLetter>
          </>
        ) : (
          message.text
        )}
      </MessageBubble>
    </MessageWrapper>
  );
}

export const MessageWrapper = styled.div<{ $isUser?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $isUser }) => ($isUser ? 'flex-end' : 'flex-start')};
  gap: 4px;
`;

const MessageBubble = styled.div<{ $isUser?: boolean }>`
  max-width: 70%;
  padding: 12px 16px;
  ${AppCSS.radiuses.regular};
  ${({ $isUser }) =>
    $isUser
      ? `
          background-color: ${AppCSS.colors.blues.primary};
          color: ${AppCSS.colors.white};
          border-bottom-right-radius: 4px;
        `
      : `
          background-color: ${AppCSS.colors.white};
          color: ${AppCSS.colors.black};
          border: 1px solid ${AppCSS.colors.greys.light};
          border-bottom-left-radius: 4px;
        `}
  ${AppCSS.fonts.label14Regular};
  line-height: 1.4;
  word-wrap: break-word;
  ${AppCSS.boxShadows.block};
`;

export const MessageSender = styled.span<{ $isUser?: boolean }>`
  ${AppCSS.fonts.label12Bold};
  color: ${({ $isUser }) => ($isUser ? AppCSS.colors.blues.primary : AppCSS.colors.greys.prettyDark)};
  padding: 0 8px;
  align-self: ${({ $isUser }) => ($isUser ? 'flex-end' : 'flex-start')};
`;

const MessageStreamedLetter = styled.span`
  opacity: 0;
  display: inline;
  animation: fadeInChar 0.1s ease-out forwards;
  @keyframes fadeInChar {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
